// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"43":"cd19898b","194":"29ea017d","479":"5136efea","741":"330cb028","845":"62e95246","950":"82ea04f2"}[chunkId] + ".chunk.js";
};